import { render, staticRenderFns } from "./IntroBuyMeList.vue?vue&type=template&id=8497d7fe&scoped=true&"
import script from "./IntroBuyMeList.vue?vue&type=script&lang=js&"
export * from "./IntroBuyMeList.vue?vue&type=script&lang=js&"
import style0 from "./IntroBuyMeList.vue?vue&type=style&index=0&id=8497d7fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8497d7fe",
  null
  
)

export default component.exports